import styles from './FooterLegalLinks.module.scss';

import cx from 'classnames';
import React, { FC, HTMLAttributes } from 'react';
import type { ExternalLink, InternalLink } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { TermsAndConditions } from 'components/TermsAndConditions/TermsAndConditions';

import { FooterPageLegalDisclaimers } from '../FooterPageLegalDisclaimers/FooterPageLegalDisclaimers';

interface IFooterLegalLinksProps extends HTMLAttributes<HTMLDivElement> {
  items?: Array<FlatEntry<ExternalLink | InternalLink>>;
  pageLegalDisclaimers?: string[];
}

const copyrightText = `\u00A9 ${new Date().getFullYear()} Clover Network, LLC `;

export const FooterLegalLinks: FC<IFooterLegalLinksProps> = ({
  items = [],
  pageLegalDisclaimers,
  className,
}) => {
  return (
    <div className={styles.footerLegalLinks}>
      <div className={styles.copyRightText}>
        {copyrightText}
        <TermsAndConditions className={styles.termsAndConditions} />
        <FooterPageLegalDisclaimers disclaimers={pageLegalDisclaimers} />
      </div>
      <div>
        <ul className={cx(className)}>
          {items?.length &&
            items.map(
              (item, index) =>
                item.title && (
                  <li key={componentKeyV2(item, index)}>
                    <ContentLinkV2 entry={item} className={styles.link} />
                  </li>
                ),
            )}
        </ul>
      </div>
    </div>
  );
};
